import { atom } from "recoil";
import { IHoistErrors } from '../views/hoist/RegisterHoistPanel'


export const hoistsErrors = atom<IHoistErrors[] | undefined>({
    key: "hoists.errors",
    default: undefined,
});

